import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { ConfirmPhonePayload } from './confirm-phone.type';

export async function confirmPhoneService({ body }: ConfirmPhonePayload) {
  const { response, data } = await BACKEND.post(ENDPOINT.CONFIRM_PHONE, { body });

  return {
    response,
    summary: data,
  };
}
